/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

import InventoryListHeader from "components/ClinicalManagement/Inventory/InventoryListHeader/InventoryListHeader";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import InventoryFilterPopup from "./Popup/InventoryFilterPopup";
import SaveInventoryPopup from "./Popup/SaveInventoryPopup";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const InventoryListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t, i18n } = useTranslation(); //for translation

  const [inventoryList, setinventoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedInventories, setSelectedInventories] = useState([]);
  const [selectedInventory, setselectedInventory] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //get all inventories
  const getAllInventories = async () => {
    setRowSelection({});
    setSelectedInventories([]);
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_INVENTORIES + `?token=${token}`;

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        setinventoryList(response.data);
      }
    } catch (error) {}
  };

  const getInventoryByFilter = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_INVENTORIES_BY_FILTER +
        `?token=${token}`;

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };
      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      setIsLoading(false);

      if (response.status) {
        setinventoryList(response.data);
      }
    } catch (error) {}
  };

  //function for delete bulk
  const deleteBulkInventories = async () => {
    if (selectedInventories.length > 0) {
      try {
        const listToBeUpdated = inventoryList.filter((item) =>
          selectedInventories.includes(item._id)
        );

        const apiData = {
          inventories: listToBeUpdated,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_INVENTORY + `?token=${token}`;

        const response = await putData(requestURL, apiData);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            getAllInventories();
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one inventory.");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //reset filter
  const resetFilter = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getInventoryByFilter();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllInventories();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getAllInventories();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasSaveInventory"
            aria-controls="offcanvasSaveInventory"
            onClick={() => {
              setselectedInventory(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      { accessorKey: "stockedon", header: "Stocked On" },
      {
        accessorKey: "tagstring",
        header: t("Label"),

        Cell: ({ row }) => (
          <div className="label border-bottom-0">
            {row.original.labels && (
              <ul className="d-flex flex-wrap gap-2 fs-xs">
                {row.original.labels.map((tag, index) => {
                  return (
                    <li
                      key={index}
                      className="px-2 py-1 gradient-light rounded-5"
                    >
                      {tag.title}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ),
      },
      { accessorKey: "sku", header: "SKU" },
      { accessorKey: "productname", header: "Product Name" },
      { accessorKey: "currentstock", header: "Current Stock" },
      { accessorKey: "stockadded", header: "Added Stock" },
      { accessorKey: "wearhousename", header: "Warehouse" },
      { accessorKey: "supplier", header: "Supplier" },
    ],
    []
  );

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedInventories(selectedIdsArray);
    } else {
      setSelectedInventories([]);
    }
  }, [rowSelection]);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_INVENTORY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Inventory")}
          />
          <div className="container-fluid px-lg-5">
            <InventoryListHeader
              reloadList={resetFilter}
              jsonFilterQuery={jsonFilterQuery}
              selectedItemIds={selectedInventories}
            />

            {/* table */}
            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={inventoryList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* ----- all pop up render here ----- */}

          <SaveInventoryPopup
            inventoryId={selectedInventory}
            setInventoryId={setselectedInventory}
            afterPopupCLose={() => {
              setTimeout(() => {
                getAllInventories();
              }, 1000);
            }}
          />

          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedInventories([]);
            }}
            onDelete={deleteBulkInventories}
            moduleName={t("inventory")}
          />

          <AddLabelModal
            moduleName="inventory"
            afterTagModalClose={() => {
              setTimeout(() => {
                getAllInventories();
              }, 2500);
            }}
            selectedIds={selectedInventories}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <InventoryFilterPopup
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilter}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            setReloadData={setReloadData}
            moduleSlug="inventorylist"
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default InventoryListBody;
